// extracted by mini-css-extract-plugin
export default {"content":"style_content__LSRot","text":"style_text__zv9lQ","image":"style_image__Ez9Ha"};